enum AnalysisTypologyEnum {
  product = 'product_analysis',
  surface = 'surface_analysis',
  water = 'water_analysis',
}

export default AnalysisTypologyEnum;
